function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M2.744 0A2.742 2.742 0 000 2.729v5.82a2.742 2.742 0 002.744 2.73h9.512A2.742 2.742 0 0015 8.548V2.73A2.742 2.742 0 0012.256 0H2.744zm0 1.091h9.512c.922 0 1.646.721 1.646 1.638v5.82c0 .917-.724 1.638-1.646 1.638H2.744c-.922 0-1.646-.72-1.646-1.637V2.729c0-.917.724-1.638 1.646-1.638zm3.11 2.183v4.73l4.39-2.365-4.39-2.365z",
  fill: "#000",
  fillOpacity: 0.5
});

function SvgVideo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgVideo;